import type { User } from "firebase/auth";
import { getOnlyDigits } from "@/utils/cpf";

const PENDING_PHONE_VALIDATED_SYNC_KEY = "reality_pending_phone_validated_sync";

export function setPendingPhoneValidatedSyncFlag(): void {
  try {
    sessionStorage.setItem(PENDING_PHONE_VALIDATED_SYNC_KEY, "1");
  } catch {
    /* ignore quota / private mode */
  }
}

export function hasPendingPhoneValidatedSyncFlag(): boolean {
  try {
    return sessionStorage.getItem(PENDING_PHONE_VALIDATED_SYNC_KEY) === "1";
  } catch {
    return false;
  }
}

export function clearPendingPhoneValidatedSyncFlag(): void {
  try {
    sessionStorage.removeItem(PENDING_PHONE_VALIDATED_SYNC_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * True when Firebase indicates the session is tied to a verified phone that matches the DB row.
 * Covers SMS (phone provider) and WhatsApp/custom-token users created with the same phone on Firebase.
 */
export function firebaseUserShowsVerifiedPhoneMatch(
  firebaseUser: User,
  dbPhone: string | undefined
): boolean {
  if (!dbPhone?.trim()) return false;

  const phoneProvider = firebaseUser.providerData?.some(
    (p) => p.providerId === "phone"
  );
  if (phoneProvider) return true;

  const fn = firebaseUser.phoneNumber;
  if (!fn) return false;

  const dfn = getOnlyDigits(fn);
  const ddb = getOnlyDigits(dbPhone);
  if (!dfn || !ddb) return false;

  const tail = (d: string) => (d.length > 11 ? d.slice(-11) : d);
  return tail(dfn) === tail(ddb);
}
